import LockScreenPage from 'views/Pages/LockScreenPage.jsx';
import LoginPage from 'views/Pages/LoginPage.jsx';
import RegisterPage from 'views/Pages/RegisterPage.jsx';

var pagesRoutes = [
    {
        path: '/iniciar-sesion',
        name: 'Iniciar Sesion',
        mini: 'LP',
        component: LoginPage
    },
    {
        path: '/crear-cuenta',
        name: 'Registrar',
        mini: 'RP',
        component: RegisterPage
    },
    {
        path: '/reiniciar-sesion',
        name: 'Reiniciar sesion',
        mini: 'LSP',
        component: LockScreenPage
    },
    {
        path: '/',
        name: 'Iniciar Sesion',
        mini: 'LP',
        component: LoginPage
    },
    {
        redirect: true,
        path: '/fsdf',
        pathTo: '/iniciar-sesion',
        name: 'Iniciar Sesión'
    }
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/pages.jsx